module.exports = __webpack_public_path__ + "media/notice.8b56917d.mp3";